import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useAuth, isProjectLead } from "@/lib/auth/AuthContext";

// Phase 2.9: Route-Guard fuer /cockpit/pl. Spiegelt das Service-Layer-Gating
// in `plBonusKpi` (pl/admin/superadmin) — Defense in Depth (CLAUDE.md
// Prinzip 2). Buchhaltung und Monteure fliegen auf "/".
export function RequireProjectLead({ children }: { children: ReactNode }) {
  const { status, user } = useAuth();
  if (status === "loading") return null;
  if (!user || !isProjectLead(user.role)) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
